import "@/App.css";
import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import MiniCart from "@/components/MiniCart";
import AuthCallback from "@/components/AuthCallback";

import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import BuildABox from "@/pages/BuildABox";
import Checkout from "@/pages/Checkout";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Account from "@/pages/Account";
import OrderTracking from "@/pages/OrderTracking";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import CateringPage from "@/pages/CateringPage";
import About from "@/pages/About";
import ReviewsPage from "@/pages/ReviewsPage";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import Policy from "@/pages/Policy";
import AdminDashboard from "@/pages/AdminDashboard";

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
}

function Layout() {
    return (
        <div className="flex min-h-screen flex-col">
            <Navbar />
            <MiniCart />
            <main className="flex-1">
                <Outlet />
            </main>
            <Footer />
        </div>
    );
}

function AppRouter() {
    const location = useLocation();
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <>
            <ScrollToTop />
            <Routes>
                <Route element={<Layout />}>
                    <Route path="/" element={<Home />} />
                    <Route path="/shop" element={<Shop />} />
                    <Route path="/product/:slug" element={<ProductDetail />} />
                    <Route path="/build-a-box" element={<BuildABox />} />
                    <Route path="/checkout" element={<Checkout />} />
                    <Route path="/account" element={<Account />} />
                    <Route path="/track" element={<OrderTracking />} />
                    <Route path="/catering" element={<CateringPage />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/reviews" element={<ReviewsPage />} />
                    <Route path="/faq" element={<FAQ />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/policy/:type" element={<Policy />} />
                    <Route path="/payment/success" element={<PaymentSuccess />} />
                    <Route path="/payment/cancel" element={<PaymentCancel />} />
                </Route>
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
        </>
    );
}

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <CartProvider>
                    <BrowserRouter>
                        <AppRouter />
                        <Toaster position="top-center" richColors closeButton toastOptions={{ style: { fontFamily: "Outfit, sans-serif" } }} />
                    </BrowserRouter>
                </CartProvider>
            </AuthProvider>
        </div>
    );
}

export default App;
